
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/touchInputs.css';
import { installGlobalErrorLogging } from './lib/eventLog';
import { installInternalApiAuth } from './lib/internalApiAuth';

// 未捕捉例外 / 未処理 Promise 拒否をサーバのイベントログへ（ループエンジニアリング基盤）
// 設計: booking-platform/md/loop-engineering.md
installGlobalErrorLogging();

// 社内 API（/sys/*）の認証をスタッフのログイントークン（Bearer）に切り替える。
// 旧共有キーは公開バンドルに漏れていたため廃止（2026-10-09。詳細は lib/internalApiAuth.ts）
installInternalApiAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register Service Worker for PWA
// 開発中および頻繁な更新が必要な管理画面のため、Service Workerによる強力なキャッシュを無効化します
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
